import { defineComponent as H, openBlock as o, createElementBlock as e, mergeProps as p, unref as n, renderSlot as i, createElementVNode as l, createCommentVNode as u } from "vue";
import { useScalarIcon as v } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, Z = { key: 1 }, h = { key: 2 }, g = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconBed"
}, A = /* @__PURE__ */ H({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const r = V, { bind: s, weight: a } = v(r);
    return (d, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(s)), [
      i(d.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", m, t[0] || (t[0] = [
        l("path", { d: "M212,68H36V48a12,12,0,0,0-24,0V208a12,12,0,0,0,24,0V180H232v28a12,12,0,0,0,24,0V112A44.05,44.05,0,0,0,212,68ZM100,156H36V92h64Zm132,0H124V92h88a20,20,0,0,1,20,20Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", Z, t[1] || (t[1] = [
        l("path", {
          d: "M248,112v56H112V80H216A32,32,0,0,1,248,112Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M216,72H32V48a8,8,0,0,0-16,0V208a8,8,0,0,0,16,0V176H240v32a8,8,0,0,0,16,0V112A40,40,0,0,0,216,72ZM32,88h72v72H32Zm88,72V88h96a24,24,0,0,1,24,24v48Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", h, t[2] || (t[2] = [
        l("path", { d: "M216,72H32V48a8,8,0,0,0-16,0V208a8,8,0,0,0,16,0V176H240v32a8,8,0,0,0,16,0V112A40,40,0,0,0,216,72ZM32,88h72v72H32Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", g, t[3] || (t[3] = [
        l("path", { d: "M216,74H30V48a6,6,0,0,0-12,0V208a6,6,0,0,0,12,0V174H242v34a6,6,0,0,0,12,0V112A38,38,0,0,0,216,74ZM30,86h76v76H30Zm88,76V86h98a26,26,0,0,1,26,26v50Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        l("path", { d: "M216,72H32V48a8,8,0,0,0-16,0V208a8,8,0,0,0,16,0V176H240v32a8,8,0,0,0,16,0V112A40,40,0,0,0,216,72ZM32,88h72v72H32Zm88,72V88h96a24,24,0,0,1,24,24v48Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", f, t[5] || (t[5] = [
        l("path", { d: "M216,76H28V48a4,4,0,0,0-8,0V208a4,4,0,0,0,8,0V172H244v36a4,4,0,0,0,8,0V112A36,36,0,0,0,216,76ZM28,84h80v80H28Zm88,80V84H216a28,28,0,0,1,28,28v52Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  A as default
};
